import Vue from "vue";
import { store } from "../store";
import VueRouter from "vue-router";
import { sync } from "vuex-router-sync";

import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    routes: routes
});

router.beforeEach((to, from, next) => {
    try {
        if (to.matched.some(record => record.meta.forVisitors)) {
            if (store.getters["AuthModule/isAuthenticated"])
                next({ path: "/" });
            else next();
        } else if (to.matched.some(record => record.meta.forAuth)) {
            if (!store.getters["AuthModule/isAuthenticated"]) {
                next({ path: "/auth/login" });
            } else {
                if (to.matched.some(record => record.meta.can)) {
                    let permissions = store.getters["AuthModule/permissions"];
                    if (permissions.indexOf(to.meta.can) > -1) {
                        next();
                    } else {
                        next();
                    }
                } else {
                    next();
                }
            }
        } else {
            next();
        }
    } catch (ex) {
        console.log("EX",ex);
    }
});
sync(store, router);
export default router;
